import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { provideTranslocoScope, TranslocoDirective } from '@jsverse/transloco';
import { RmaIconComponent } from '@rma/generic/ui/icon';
import { AppendReturnUrlParamsPipe } from '@rma/public/generic/util/router-utils';
import { COMPARE_AGENT_SCOPE } from '../domain/translation-scope';

@Component({
  selector: 'rma-login-gate',
  templateUrl: './login-gate.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [provideTranslocoScope(COMPARE_AGENT_SCOPE)],
  imports: [AppendReturnUrlParamsPipe, MatButtonModule, RmaIconComponent, RouterLink, TranslocoDirective],
  host: {
    class: 'grid grid-cols-1',
  },
})
export class LoginGateComponent {
  protected readonly scope = `${COMPARE_AGENT_SCOPE}.loginGate`;

  public readonly gated = input.required<boolean>();
  public readonly showCard = input<boolean>(false);
}
